// TODO: vote_keirin_jushouと重複している部分をmixinとして切り出す
import "../app";
import Vue from "vue/dist/vue.esm";
import ModulesPopup from '../modules/popup';
import keirinNormalAthletes from './normal_athletes';
import keirinHistoryAthletes from './history_athletes';
import keirinNarabi from './components_narabi';
import componentsVotings from './components_votings';
import componentsSupportRates from './components_support_rates';

var popup = {
  extends: ModulesPopup.popup,
  props: ['popupData']
};

var normalAthletesTable = {
  extends: keirinNormalAthletes.normalAthletes,
  props: ['raceInfo']
};

var historyAthletesTable = {
  extends: keirinHistoryAthletes.historyAthletesTable,
  props: ['raceInfo']
};

// 競輪並び図
var narabiRowDetail = {
  extends: keirinNarabi.keirinNarabiRowDetail,
  props: ['raceInfo', 'narabi']
};

var graphVotings = {
  extends: componentsVotings.graphVotings,
  props: ['state']
};

var graphSupportRates = {
  extends: componentsSupportRates.graphSupportRates,
  props: ['state']
};

var appId = document.getElementById('js-keirin-jushous');
var open_day = appId.getAttribute('data-open_day');
var vel_code = appId.getAttribute('data-vel_code');

const vm = new Vue({
  el: '#vue-jushou-status',
  data: {
    state: {
      elShow: false,
      boxes: [],
      box: {},
      debug: false,
      open_day: open_day,
      vel_code: vel_code,
      race_num: '', // 出走表取得用
      box_type: '',
      box_id: '',
      selectedRaceIndex: 0, // race_numではなくrace配列のindex
      voteType: {
        votings: {
          isActive: true,
          name: '状況'
        },
      },
      entries: [],
      editCart: {},
      setCart: [],
      votings: [],
      histories: {},
      predictions: [],
      nagai_predictions: []
      // voteList: {}
    },
    popupData: {
      show: false,
      content: '',
      callback: '',
      isAlert: false,
      propsLoading: false
    },
    raceInfo: {}, // モーダルで選手情報を表示する用
    narabi: []
  },
  methods: {
    switchTab: function(index) {
      if (this.state.boxes[index].isActive) {
        return false;
      }

      for (var i=0; i < this.state.boxes.length; i++) {
        this.state.boxes[i].isActive = false;
      }
      this.state.boxes[index].isActive = true;
      this.state.box = this.state.boxes[index];
      this.state = chari.util.deepCopy(this.state);

      this.geneEntries(this.state.box);

      this.state.voteType['votings'].isActive = true;
      this.fetchVotings();
    },
    geneEntries: function(obj) {
      var entriesRowCount = this.entriesRowCount;
      var entriesColCount = 9; // システム上想定されている最大の車番数
      var entries = [];
      var entriesStatuses = obj.entries_for_kuji;

      for (var i=0; i < entriesRowCount; i++) {
        var entriesRow = {};

        for (var j=0; j < entriesColCount; j++) {
          var entryNumber = String(j + 1);

          entriesRow[entryNumber] = {
            vote:false,
            kessha:false,
            on_sale:false
          };
        }

        entries.push(entriesRow);
      }

      this.state.entries = entries;
      this.checkKessha(entriesStatuses);
    },
    displayRaceInfo: function(num, type) {
      this.state.race_num = parseInt(num);
      this.popupData.propsLoading = true;

      if (type === 'raceTableNormal') {
        this.fetchRaceInfo(function () {
          this.popupData.currentView = normalAthletesTable;
          this.popupData.propsLoading = false;
        }.bind(this));
      } else if (type === 'raceTableHistory') {
        this.fetchRaceInfo(function () {
          this.popupData.currentView = historyAthletesTable;
          this.popupData.propsLoading = false;
        }.bind(this));
      } else if (type === 'narabiDetail') {
        this.fetchRaceInfo(function () {
          this.fetchNarabi(function () {
            this.popupData.currentView = narabiRowDetail;
            this.popupData.propsLoading = false;
          }.bind(this));
        }.bind(this));
      }

      this.popupData.show = true;
    },
    // entries_for_kujiのデータからUI用のデータを生成
    // 欠車と発売中の状態は区別する
    checkKessha: function(arr) {
      var statuses = arr;

      for (var i=0; i < statuses.length; i++) {
        if (statuses[i].length > 0) {
          for (var j=0; j < statuses[i].length; j++) {
            var status = statuses[i][j];
            var syaban = (j + 1).toString();

            if (status === 'unregistered') {
              this.state.entries[i][syaban].on_sale = false;
            } else if (status === 'pre_cancel' || status === 'after_cancel') {
              this.state.entries[i][syaban].kessha = true;
            } else if (status === 'on_sale') {
              this.state.entries[i][syaban].on_sale = true;
            }
          }
        }
      }
    },

    fetchJushousWithVelCode: function(open_day, vel_code) {
      $.ajax({
        url: '/api/keirin_jushous/list_with_vel_code',
        contentType: 'application/json',
        data: {
          open_day: this.state.open_day,
          vel_code: this.state.vel_code
        }
      }).done(function(res) {
        this.state.boxes = res.filter(function(e, i, a) {
          return !e.kuji_question;
        });

        for (var i=0; i < this.state.boxes; i++) {
          this.state.boxes[i].isActive = false;
        }
        this.state.boxes[0].isActive = true;

        this.state.box = this.state.boxes[0];
        this.geneEntries(this.state.box);
        this.state.box_id = res[0].id;

        this.fetchVotings();
      }.bind(this));
    },

    fetchVotings: function() {
      chari.api.getKeirinJushouVotings({
        keirin_box_id: this.state.box.id
      },(function(res) {
        this.state.votings = res;
      }).bind(this));
    },

    fetchSupportRates: function() {
      $.ajax({
        url: '/api/keirin_jushous/support_rates',
        dataType: 'json',
        data:{ keirin_box_id: this.state.box.id }
      }).done(function(res) {
        this.state.support_rates = res;
      }.bind(this));
    },

    fetchNarabi: function(cb) {
      chari.api.getKeirinPrediction({
        open_day: this.state.open_day,
        vel_code: this.state.vel_code,
        race_num: this.state.race_num
      },(function(res) {
        this.narabi = res.predictions;
        if (cb) {
          cb();
        }
      }).bind(this));
    },

    fetchRaceInfo: function(cb) {
      chari.api.getKeirinRaceInfo({
        open_day: this.state.open_day,
        vel_code: this.state.vel_code,
        race_num: this.state.race_num
      }, (function(res) {
        this.raceInfo = res;
        if (cb) {
          cb();
        }
      }).bind(this));
    },
    // 第二引数をtrueで割合を整数以下切り捨てで返す
    getSupportRates: function(key, isPercentage) {
      if (this.state.support_rates.length > 0) {
        if (isPercentage) {
          return chari.util.adjustNum((this.state.support_rates[this.state.selectedRaceIndex].votes[key] / this.state.support_rates[this.state.selectedRaceIndex].total_votes) * 100, 0, false);
        } else {
          return this.state.support_rates[this.state.selectedRaceIndex].votes[key];
        }
      }
    },
    // 対象のレースの車番をまとめて切り替える
    toggleSyabanEachRace: function(raceIndex) {
      var entriesVoteStatus = [];
      // 対象レースの車番の選択状態を配列に格納
      for (let key in this.state.entries[raceIndex]) {
        if (!this.state.entries[raceIndex][key].kessha && this.state.entries[raceIndex][key].on_sale) {
          entriesVoteStatus.push(this.state.entries[raceIndex][key].vote);
        }
      }
      // 対象レースの車番がすべて選択済みかそうでないかの判定
      var flg = entriesVoteStatus.every(function(element, index, array) {
        return element;
      });
      // もし対象レースの車番がすべて選択済みなら全ての選択を外す
      // そうでないなら全ての車番を選択状態にする
      if (flg) {
        for (let key in this.state.entries[raceIndex]) {
          if (!this.state.entries[raceIndex][key].kessha && this.state.entries[raceIndex][key].on_sale) {
            this.state.entries[raceIndex][key].vote = false;
          }
        }
      } else {
        for (let key in this.state.entries[raceIndex]) {
          if (!this.state.entries[raceIndex][key].kessha && this.state.entries[raceIndex][key].on_sale) {
            this.state.entries[raceIndex][key].vote = true;
          }
        }
      }
    },

  },
  created: function() {
    this.fetchJushousWithVelCode(this.state.open_day, this.state.box_type);
  },
  mounted: function() {
    this.state.elShow = true;
  },
  computed: {
    entries: function() {
      return this.state.entries;
    },
    entriesRowCount: function() {
      return this.state.box.race_row - this.state.box.wins_begin_race_num + 1;
    }
  },
  components: {
    popup: popup,
    normalAthletesTable: normalAthletesTable,
    historyAthletesTable: historyAthletesTable,
    narabiRowDetail: narabiRowDetail,
    graphVotings: graphVotings,
    graphSupportRates: graphSupportRates
  }
});
